import React from 'react';

// ui
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { MonthPicker } from '@/components/ui/month-picker';
import { useMainContext } from '@/context/main-context';
import { GraduationCapIcon, Users } from 'lucide-react';
import Groups from './groups/groups';

function MainPage() {
  const { groups, teacherData } = useMainContext();
  const [month, setMonth] = React.useState(new Date());


  const totalStudents = groups.reduce((acc, group) => {
    if (group.status && group.students) {
      return acc + group.students.length;
    }
    return acc;
  }, 0);

  return (
    <div className="px-4 my-3 lg:my-2 mx-auto space-y-4">
      <div className="space-y-2">
        <div className="flex items-center justify-between space-y-2">
          <div className="flex items-center gap-2">
            {/* <SheetMenu /> */}
            <h2 className="text-lg lg:text-xl font-bold text-muted-foreground tracking-tight">
              Welcome, <span className="text-primary text-lg">{teacherData.fullName}</span>
            </h2>
          </div>
          <div className="hidden md:hidden items-center space-x-2">
            <MonthPicker month={month} setMonth={setMonth} />
          </div>
        </div>
      </div>
      <div className="grid gap-4 md:grid-cols-2">
        <Card className="dark:bg-background/95">
          <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
            <CardTitle className="text-sm font-medium">Guruhlar</CardTitle>
            <Users className="h-4 w-4 text-muted-foreground" />
          </CardHeader>
          <CardContent>
            <div className="text-2xl font-bold">{groups.length} ta</div>
          </CardContent>
        </Card>
        <Card className="dark:bg-background/95">
          <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
            <CardTitle className="text-sm font-medium">Talabalar</CardTitle>
            <GraduationCapIcon className="h-4 w-4 text-muted-foreground" />
          </CardHeader>
          <CardContent>
            <div className="text-2xl font-bold">{totalStudents} ta</div>
          </CardContent>
        </Card>
      </div>

      <Groups fromMain={true} />

      {/* <h4>Darslar jadvali</h4>
      <LessonsSchedule fromMain={true} /> */}
    </div>
  );
}

export default MainPage;
